module.exports = __webpack_public_path__ + "img/biaoqian_youzheng.964a8222.png";